import { render } from "./Admin-form.vue?vue&type=template&id=02ec2a38&scoped=true"
import script from "./Admin-form.vue?vue&type=script&lang=js"
export * from "./Admin-form.vue?vue&type=script&lang=js"

import "./Admin-form.vue?vue&type=style&index=0&id=02ec2a38&scoped=true&lang=css"

import exportComponent from "/Users/thomas/Desktop/CNT/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02ec2a38"]])

export default __exports__